document.addEventListener("DOMContentLoaded", function () {
    setTimeout(()=> {
        const onetimeLabel = document.querySelector(".rc-widget .onetime-radio .rc-radio__label")
        if (onetimeLabel) {
          onetimeLabel.innerHTML = "One-Time Delivery"
        }
    }, 400)  

  // Recharge ajax patch
  // Selling plan inputs aree added to the wrong form if the product is present in mini cart upsells
  // Listen for input getting added to mini cart upsell form
  // Remove it and add it to the correct form
  const mincartUpsell = document.querySelector('.minicart-upsell-wrap')
  if (mincartUpsell) {

    // handle page reload
    const urlParams = new URLSearchParams(window.location.search);
    const sellingPlan = urlParams.get('selling_plan');

    if(sellingPlan) {
      const productAddToCart = document.querySelector('.product-block .product-single__form') 
      const productSellingPlan = productAddToCart.querySelector('input[name="selling_plan"]')
      if (productSellingPlan) {
        productSellingPlan.value = sellingPlan
      } else {
        productAddToCart.insertAdjacentHTML("afterbegin", `<input name="selling_plan" type="hidden" value="${sellingPlan}">`)
      }
      const upsellInputs = mincartUpsell.querySelectorAll('input[name="selling_plan"]')
      upsellInputs.forEach(upsellInput => {
        upsellInput.value = ''
      })
    }
    
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          if (mutation.target.getAttribute('name') === 'selling_plan'){
            const sellingPlanDropdown = document.querySelector('.rc-selling-plans-dropdown__select')
            const productAddToCart = document.querySelector('.product-block .product-single__form') 
            const productSellingPlan = productAddToCart.querySelector('input[name="selling_plan"]')

            if (sellingPlanDropdown) {
              const sellingPlanId = sellingPlanDropdown.value            
              if (productSellingPlan) {
                productSellingPlan.value = sellingPlanId
              } else {
                productAddToCart.insertAdjacentHTML("afterbegin", `<input name="selling_plan" type="hidden" value="${sellingPlanId}">`)
              }
            } else {
              productSellingPlan.value = ''
            }
            observer.disconnect();
            mutation.target.value = '';
            observer.observe(mutation.target, config);
          }          
        }
      }
    };
    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(callback);
    const upsellForms = mincartUpsell.querySelectorAll('.minicart-upsell');
    upsellForms.forEach(upsellForm => {
      observer.observe(upsellForm, config);
    })
  }


})

